import { PageRoutes } from "../../../constants/historyGaming";
import { useLocation, useSearchParams } from "react-router-dom";
import FooterNavigation from "./FooterNavigation";
import VerticalFooterNavigation from "./VerticalFooterNavigation";
import { useAppSelector } from "../../hooks";

const BottomNavbar: React.FC = () => {
  const { theme } = useAppSelector((state) => state.theme);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const hasShopTab  = pathname === PageRoutes.Shop && !!tab;

  if (hasShopTab) return null;

  const layout = theme?.theme || "legacy";
  switch (layout) {
    case "vertical":
      return <VerticalFooterNavigation />;

    case "legacy":
    default:
      return <FooterNavigation />;
  }
};

export default BottomNavbar;
